import { apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { Safeguarding } from '../types';

export const safeguardingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSafeguardingReport: build.query<{ data: Safeguarding }, string>({
      query: (query) => ({
        url: `/v1/reports/safeguarding${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getSafeguardingCryptoReport: build.query<{ data: Safeguarding }, string>({
      query: (query) => ({
        url: `/v1/reports/crypto-safeguarding${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportSafeguardingReport: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/safeguarding/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportSafeguardingCryptoReport: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/crypto-safeguarding/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportSafeguardingReportWithAccounts: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/safeguarding/accounts/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportSafeguardingCryptoReportWithAccounts: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/crypto-safeguarding/accounts/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useExportSafeguardingReportMutation,
  useLazyGetSafeguardingReportQuery,
  useExportSafeguardingReportWithAccountsMutation,
  useLazyGetSafeguardingCryptoReportQuery,
  useExportSafeguardingCryptoReportMutation,
  useExportSafeguardingCryptoReportWithAccountsMutation,
} = safeguardingApi;

export const {
  endpoints: {
    getSafeguardingReport,
    exportSafeguardingReport,
    exportSafeguardingReportWithAccounts,
    getSafeguardingCryptoReport,
    exportSafeguardingCryptoReport,
    exportSafeguardingCryptoReportWithAccounts,
  },
} = safeguardingApi;
